import React from 'react';
import {CommonCreate} from '../Common';
import {getInputs} from './Common';

export const ContractCreate = props => <CommonCreate {...props} fields={getInputs()} />;
